import { ICourse, ICourse2 } from '@et/types/Courses'
import DefaultTheme from '@styles/themes/defaultTheme'
import { PAYMENT_TYPES_THEME } from '@et/types/Enums'
// TODO: reg price link and sale price link so we only have to change one item
const slug = 'gouache-botanicals-in-procreate'
const title = 'Gouache Botanicals in Procreate'
const course: ICourse2 = {
  theme: PAYMENT_TYPES_THEME.LIGHT,
  title,
  slug,
  videoId: `jd4i46f3lp`,
  keywords: [
    'gouache', 'procreate', 'painting', 'hand painted', 'procreate brushes', 'gouache flowers', 'gouache texture', 'ipad', 'procreate tutorial painting', 'gouache texture', 'tutorial', 'tutorials', 'how to', 'procreate gouache brushes', 'procreate tutorial gouache', 'in depth procreate tutorial', 'procreate tutorial gouache', 'gouache painting in procreate', 'gouache brushes', 'how to add brushes to procreate', 'how to install procreate brushes', 'botanicals', 'learn', 'learning', 'course', 'online course', 'procreate painting course', 'step-by-step',
  ],
  price: '197',
  salePrice: '147',
  paymentPlan:{
    price: '75',
    perMonth: '3 Payments of $75/m',
    savings: '12%'
  },
  motionMail: `https://s.mmgo.io/t/CBPI/scale_2x`,
  onSale: false,
  tagline: 'Learn how to digitally paint gouache botanicals in 4 gouache-inspired painting styles',
  classDescriptor: 'Learn how to digitally paint gouache botanicals in 4 gouache-inspired painting styles',
  intro: {
    imgName: 'procreate301/tablet-intro.png',
    imgAlt: 'Welcome to 3d Lettering in Procreate',
    bullets: [
      {
        title: 'Beginner Friendly',
        desc:
          'Step-by-step narration with closeups on all the details, so you feel confident in the process from start to finish.',
      },
      {
        title: 'A Versatile Process',
        desc:
          'Since every lettering style is different, this process has been fine-tuned to fit any situation. You’ll be able to achieve a realistic watercolor effect when you apply it to any style - hand lettered or typed.',
      },
      {
        title: 'Blend Options',
        desc:
          'You may want an ombré, one color, smooth transitions blend with one of your pieces and a multi-colored blend with water pockets on another. This course serves up 5 different blend options, so you’ll have plenty to choose from when you begin your next lettering piece.',
      },
      {
        title: 'Florals + Foliage Integration',
        desc:
          'Take your watercolor lettering even further by integrating florals and foliage! A bonus florals foundations module is included, so even if you’ve never painted florals before, you’ll be able to follow along and complete every project in the class.',
      },
    ],
  },
  projects: {
    beginner: [
      {
        title: 'Project 1',
        backgroundColor: `#7fb5e4`,
        textColor: `#4a5457`,
        subheadColor: `#fff`,
        projectImg: `procreate301/project-1.jpg`,
        projectImgMobile: `procreate301/project-1.jpg`,
        type: 'flat style',
        desc:
          'After some foliage and floral flat style warm up exercises, the course kicks off with some flat style blueberries! Utilizing minimal brushes and a simple, bold style, this bunch of blueberries is the perfect base to begin building skills as the course progresses.',
      },
      {
        title: 'Project 2',
        backgroundColor: `#006c24`,
        textColor: `#d5e4d9`,
        subheadColor: `#fcb900`,
        projectImg: `procreate301/project-2.jpg`,
        projectImgMobile: `procreate301/project-2-mobile.jpg`,
        type: 'flat style',
        desc:
          'In project 2, we add complexity to our flat style by using additional colors within the same element. We explore more complex layering for our individual items which helps to mimic depth within the flat style.',
      },
      {
        title: 'Project 3',
        backgroundColor: `#719b81`,
        textColor: `#313428`,
        subheadColor: `#f3ecdf`,
        projectImg: `procreate301/project-3.jpg`,
        projectImgMobile: `procreate301/project-3-mobile.jpg`,
        type: 'flat style',
        desc: 'In the most complex flat style project of the course, we create multiple elements created from multiple components, painted in an intentional order.',
      },
      {
        title: 'Project 4',
        type: 'chunky style',
        projectImg: `procreate501/project-4.jpg`,
        projectImgMobile: `procreate301/project-4-mobile.jpg`,
        backgroundColor: `#dee5dd`,
        textColor: `#565857`,
        subheadColor: `#c56b00`,
        desc:
          'After getting comfortable with the flat style and completing the chunky style warm ups, we move onto our first chunky style project: the lemons! In this intro project to the style, we begin color blocking and painting using a much wider palette and shorter strokes.',
      },
      {
        title: 'Project 5',
        type: 'chunky style',
        projectImg: `procreate301/project-5.jpg`,
        projectImgMobile: `procreate301/project-5-mobile.jpg`,
        backgroundColor: `#ffd5bc`,
        textColor: `#613e2d`,
        subheadColor: `#419187`,
        desc:
          'This project is the closest acrylic-like aesthetic in the course. We take advantage of gouache’s ability to layer color and create a sense of depth with many strokes throughout numerous stems, petals and leaves for a dense and colorful bouquet.',
      },
      {
        title: 'Project 6',
        type: 'chunky style',
        projectImg: `procreate301/project-6.jpg`,
        projectImgMobile: `procreate301/project-6-mobile.jpg`,
        backgroundColor: `#11230e`,
        textColor: `#9cae94`,
        subheadColor: `#be8d87`,
        desc:
          'In our only project with a dark background, we create pops of realism through brightly colored petals, contrasted with dark leaves and shadows within the rose itself. Paying attention to complex layering and many color changes, the result is a stunning, painterly rose.',
      },
      {
        title: 'Bonus Project 1',
        type: 'smooth style',
        projectImg: `procreate301/project-7.jpg`,
        projectImgMobile: `procreate301/project-7-mobile.jpg`,
        backgroundColor: `#67985d`,
        textColor: `#f3f0eb`,
        subheadColor: `#f4d547`,
        desc:
          'We return back to our lemons for the first bonus project in the smooth style. By replicating our chunky style work, we’re able to easily create a realistic painting with just a few simple steps.',
      },
      {
        title: 'Bonus Project 2',
        type: 'smooth style',
        projectImg: `procreate301/project-8.jpg`,
        projectImgMobile: `procreate301/project-8-mobile.jpg`,
        backgroundColor: `#11230e`,
        textColor: `#9cae94`,
        subheadColor: `#be8d87`,
        desc:
          'In our final bonus project, we smooth out the chunky rose version to bring its realism up an extra notch, meticulously smoothing in all the right areas and directions for a touchable look.',
      },
      {
        title: 'Project 7',
        type: 'large stroke style',
        projectImg: `procreate301/project-8.jpg`,
        projectImgMobile: `procreate301/project-8-mobile.jpg`,
        backgroundColor: `#67985d`,
        textColor: `#f3f0eb`,
        subheadColor: `#f4d547`,
        desc:
          'We kick off our final gouache inspired painting style using our lemons once again. In this project, we marry our flat style with our chunky style for a mid-sized palette made up of large, beautifully streaky strokes and a different painterly aesthetic.',
      },
      {
        title: 'Project 8',
        type: 'large stroke style',
        projectImg: `procreate301/project-8.jpg`,
        projectImgMobile: `procreate301/project-8-mobile.jpg`,
        backgroundColor: `#c9c5b2`,
        textColor: `#4f4f4f`,
        subheadColor: `#84602c`,
        desc:
          'Since large petals lend themselves perfectly to the large stroke style, in this project, we challenge ourselves with different shades of white, mixed with extra texture contrast when we introduce our dried out brush within the same style.',
      },
      {
        title: 'Project 9',
        type: 'large stroke style',
        projectImg: `procreate301/project-8.jpg`,
        projectImgMobile: `procreate301/project-8-mobile.jpg`,
        backgroundColor: `#9aa8a4`,
        textColor: `#f5f5f4`,
        subheadColor: `#3a594e`,
        desc:
          'As the course progresses, the projects become more complex and in this project, we alter the layout of the source image slightly and once again bring in our dried out brush for extra texture contrast. Using colorful petals this time, we layer and smooth out different areas for an eye catching floral.',
      },
      {
        title: 'Project 10',
        type: 'mixed stroke style',
        projectImg: `procreate301/project-8.jpg`,
        projectImgMobile: `procreate301/project-8-mobile.jpg`,
        backgroundColor: `#a488cf`,
        textColor: `#f5f5f4`,
        subheadColor: `#544143`,
        desc:
          'Our grand finale! In this final project, we bring all of our different styles together in one dense and varied bouquet. We utilize different brushes, all of the techniques throughout the class and keep things layered and organized to keep the complexity under control. The result is a painterly and realistic multi-textured bouquet.',
      },
    ],
    advanced: [],
  },
  curriculum: [
    {
      title: 'Welcome + Bonuses',
      videos: [
        {
          title: 'What You\'ll Learn/Class Overview',
          duration: '7:48',
        },
        {
          title: 'Bonuses location/install instructions',
          duration: '2:56',
        },
      ],
    },
    {
      title: 'Getting Started',
      videos: [
        {
          title: 'Helpful Links',
          duration: '5:10',
        },
        {
          title: 'Using source photos correctly',
          duration: '3:28',
        },
        {
          title: 'Painting process options: beginner/intermediate/advanced',
          duration: '5:07',
        },
        {
          title: 'Tips About File Size',
          duration: '6:13',
        },

      ],
    },
    {
      title: 'Gouache Painting Overview',
      videos: [
        {
          title: 'Traditional gouache painting styles',
          duration: '10:33',
        },
        {
          title: 'Gouache Lovers Procreate brushes overview',
          duration: '9:15',
        },
      ],
    },
    {
      title: 'Flat Style Warm Ups',
      videos: [
        {
          title: 'Flat Style Foliage: Rose Branch',
          duration: '15:40',
        },
        {
          title: 'Flat Style Foliage: Silver Dollar Eucalyptus Part 1',
          duration: '9:52',
        },
        {
          title: 'Flat Style Foliage: Silver Dollar Eucalyptus Part 2',
          duration: '11:13',
        },
        {
          title: 'Flat Style Floral: Primroses',
          duration: '6:46',
        },
        {
          title: 'Flat Style Floral: Purple Aster',
          duration: '7:23',
        },
      ],
    },
    {
      title: 'Project 1: Flat Style Blueberries',
      videos: [
        {
          title: 'Painting the blueberries',
          duration: '7:17',
        },
        {
          title: 'Finishing up: leaves and background',
          duration: '7:01',
        },
      ],
    },
    {
      title: 'Project 2: Flat Style Lemons',
      videos: [
        {
          title: 'Painting the lemons',
          duration: '5:42',
        },
        {
          title: 'Painting the leaves',
          duration: '5:25',
        },
        {
          title: 'Finishing up: branch and background',
          duration: '5:00',
        },
      ],
    },
    {
      title: 'Project 3: Flat Style Oranges',
      videos: [
        {
          title: 'Painting an orange',
          duration: '7:40',
        },
        {
          title: 'Completing the oranges',
          duration: '9:04',
        },
        {
          title: 'Painting the large branch',
          duration: '7:59',
        },
        {
          title: 'Finishing up: small branch and background',
          duration: '7:32',
        },
      ],
    },
    {
      title: 'Chunky Style Warm Ups',
      videos: [
        {
          title: 'Chunky Style Foliage: Rose Branch',
          duration: '15:08',
        },
        {
          title: 'Chunky Style Floral: Blue Flax',
          duration: '16:12',
        },
      ],
    },
    {
      title: 'Project 4: Chunky Style Lemons',
      videos: [
        {
          title: 'Color blocking',
          duration: '6:09',
        },
        {
          title: 'Painting the lemons',
          duration: '3:45',
        },
        {
          title: 'Painting the leaves',
          duration: '10:22',
        },
        {
          title: 'Finishing up: branches and background',
          duration: '5:02',
        },
      ],
    },
    {
      title: 'Project 5: Chunky Style Bouquet',
      videos: [
        {
          title: 'Color blocking',
          duration: '9:54',
        },
        {
          title: 'Stem details',
          duration: '4:40',
        },
        {
          title: 'Painting the petals',
          duration: '9:17',
        },
        {
          title: 'Finishing up: final details and background',
          duration: '7:21',
        },
      ],
    },
    {
      title: 'Project 6: Chunky Style Rose',
      videos: [
        {
          title: 'Color blocking',
          duration: '7:57',
        },
        {
          title: 'Painting the petals',
          duration: '7:09',
        },
        {
          title: 'Painting the leaves',
          duration: '7:43',
        },
      ],
    },
    {
      title: 'Bonus: Smooth Style Warm Ups',
      videos: [
        {
          title: 'Smooth Style Foliage: Rose Branch',
          duration: '9:01',
        },
        {
          title: 'Smooth Style Floral: Blue Flax',
          duration: '9:52',
        },
      ],
    },
    {
      title: 'Bonus Project: Smooth Style Lemon',
      videos: [
        {
          title: 'Smoothing the lemons',
          duration: '4:33',
        },
        {
          title: 'Smoothing the leaves',
          duration: '6:07',
        },
      ],
    },
    {
      title: 'Bonus Project: Smooth Style Rose',
      videos: [
        {
          title: 'Smoothing the petals',
          duration: '10:07',
        },
        {
          title: 'Smoothing the leaves',
          duration: '4:33',
        },
      ],
    },
    {
      title: 'Large Stroke Warm Ups',
      videos: [
        {
          title: 'Large Stroke Foliage: Olive Branch',
          duration: '9:27',
        },
        {
          title: 'Large Stroke Foliage: Magnolia Branch',
          duration: '7:09',
        },
        {
          title: 'Large Stroke Floral: Chicory',
          duration: '4:55',
        },
        {
          title: 'Large Stroke Floral: Cosmos',
          duration: '7:51',
        },
      ],
    },
    {
      title: 'Project 7: Large Stroke Lemons',
      videos: [
        {
          title: 'Painting the lemons',
          duration: '5:27',
        },
        {
          title: 'Painting the leaves',
          duration: '4:10',
        },
        {
          title: 'Finishing up: stems and background',
          duration: '3:18',
        },
      ],
    },
    {
      title: 'Project 8: Large Stroke Magnolia',
      videos: [
        {
          title: 'Painting the petals',
          duration: '10:12',
        },
        {
          title: 'Painting the stem',
          duration: '7:26',
        },
        {
          title: 'Finishing up: leaves and background',
          duration: '8:21',
        },
      ],
    },
    {
      title: 'Project 9: Large Stroke Peony',
      videos: [
        {
          title: 'Color blocking',
          duration: '6:46',
        },
        {
          title: 'Painting the petals',
          duration: '12:19',
        },
        {
          title: 'Painting the stamen',
          duration: '4:10',
        },
        {
          title: 'Finishing up: stem, leaves and background',
          duration: '9:46',
        },
      ],
    },
    {
      title: 'Project 10: Mixed Stroke Bouquet',
      videos: [
        {
          title: 'Color blocking',
          duration: '10:57',
        },
        {
          title: 'Painting the little blue flowers',
          duration: '9:29',
        },
        {
          title: 'Painting roses, part 1',
          duration: '11:29',
        },
        {
          title: 'Painting roses, part 2',
          duration: '10:42',
        },
        {
          title: 'Painting hydrangeas',
          duration: '12:00',
        },
        {
          title: 'Painting lavender',
          duration: '12:07',
        },
        {
          title: 'Painting white florals',
          duration: '9:14',
        },
        {
          title: 'Finishing up: foliage, ribbon and background',
          duration: '16:22',
        },
      ],
    },
    {
      title: 'Exporting Your Artwork',
      videos: [
        {
          title: 'Changing colors',
          duration: '10:40',
        },
        {
          title: 'Saving on a transparent background',
          duration: '3:47',
        },
        {
          title: 'Exporting the right file type',
          duration: '3:18',
        },
      ],
    },
    {
      title: 'Thank You',
      videos: [
        {
          title: 'Thank You + Next Steps',
          duration: '3:02',
        },
      ],
    },
  ],
  bonuses: {
    headerImgName: `procreate301/bonus-title.png`,
    imgAlt: 'Watercolor lettering in Procreate Bonuses',
    gridType: 2,
    items: [
      {
        title: 'Gouache Lovers Procreate Brush Set',
        desc: 'The full Procreate brush set (12 brushes!) are included with your enrollment so you can follow along exactly. Brushes include opaque, semi transparent, diluted paint, sketching and dry brush styles to have any option you’d like in your gouache artwork.',
        imgName: 'procreate501/bonus-1.jpg',
      },
      {
        title: 'Extended License of the brushes',
        desc: 'An extended license of the brush set ($30 value) is included, so you can create unlimited artwork now and in the future with full permissions to sell it.',
        imgName: 'procreate501/bonus-2.jpg',
      },
      {
        title: '2 Bonus Smooth Style Projects',
        desc: 'Create extra realistic work utilizing the smooth style! Bonus videos include two full projects and two warm up exercises (one foliage + one floral).',
        imgName: 'procreate501/bonus-3.jpg',
      },
      {
        title: 'Exporting your artwork module',
        desc: 'Learn how to alter color after your project is finished, the right file type to export and how to save your work with a transparent background.',
        imgName: 'procreate501/bonus-4.jpg',
      },
      {
        title: 'Traditional gouache painting overview',
        desc: 'See how traditional gouache is used so you can accurately interpret your digital versions into indiscernible comparisons.',
        imgName: 'procreate501/bonus-5.jpg',
      },
      {
        title: 'Every project’s Procreate file',
        desc: 'If you ever get stuck or would like to reference the full file for any project, all 12 project files are available to you as free downloads.',
        imgName: 'procreate501/bonus-6.jpg',
      },
    ],
  },
  courseCard: {
    title: 'Lettering in Procreate',
    backgroundImgName: ``,
    backgroundColor: '#65807c',
    cardImgName: `procreate301/watercolor-class-card-4.jpg`,
    desc: 'Create beautiful and realistic watercolor lettering in Procreate! Learn versatile blending options, several texturing options and final details to bring your digital watercolor artwork to life. Created with beginners in mind, every step is described in detail, with clear control close ups and repetition for easy learning. This project based course makes learning fun with 8 unique projects to up your social media game at the same time. Get a bonus dose of inspiration and artwork options with florals and foliage foundations, so you’ll be able to create the stunning digital watercolor lettering compositions you’ve always wanted.',
    bullets: [
      'Access to 33 HD step-by-step videos',
      'Every project’s color palette',
      '8 unique watercolor lettering projects',
      'Bonus Florals + Foliage Foundations module',
      'Complete Procreate Watercolor Lettering Brush Pack (8 custom brushes)',
      'Extended license of the Procreate Watercolor Lettering Brush Pack',
      '4 unique watercolor paper textures',
      'Every project’s fully layered original Procreate file',
      'Unlimited updates',
      'Lifetime access to the class',
    ],
    brush: {
      enabled: true,
      image: {
        pencil: `apple2-pencil.png`,
        shadow: `sell-card-pencil-reflection-light.png`,
      },
    },
    priceColor: `#75A79E`,
    saleColor: `#ED856A`,
    stats: {
      modules: `#cc836f`,
      videos: `#758384`,
      hours: `#a79e8d`,
    },
  },
  faqs: [
    {
      question: 'Do you offer any refunds or guarantees?',
      answer: '<p>Yep! If you finish the course and feel you haven’t learned anything new, email me within 14 days of purchase for a full refund.</p>',
    },
    {
      question: 'How long can I access the course for?',
      answer: '<p>Forever! As long as Every Tuesday exists, this course will be available to watch. Take it at whatever pace you’d like, watch whenever, wherever and as many times as you’d like.</p>',
    },
    {
      question: 'Is this a live or pre-recorded course?',
      answer: '<p>This course is entirely pre-recorded, so you can take it whenever it works best with your schedule.</p>',
    },
    {
      question: 'Does this class come with subtitles/closed captions?',
      answer: '<p>Yep! There are English subtitles available for all videos.</p>',
    },
    {
      question: 'What will I need to take this class?',
      answer: '<p>You’ll need the Procreate app (v. 5.1.5 or newer), a pressure sensitive iPad (see this <a class="bold" target="_blank" href="https://every-tuesday.com/ipads">list</a>) and a stylus compatible with that iPad (I recommend the Apple Pencil over third party styluses).</p>',
    },
    {
      question: 'Do I need any special Procreate brushes to create these projects?',
      answer: '<p>Yes, and they’re all included for free with your enrollment! Refer to the course video titled ‘bonuses and install instructions’ for their location and a full installation tutorial.</p>',
    },
    {
      question: 'I noticed there’s a similar course offered on Skillshare. What’s the difference?',
      answer: '<p>The course on Skillshare is an intro version of this course that only includes the first 2 flat style projects of this class. For a full comparison of the two versions, please view this <a class="bold" target="_blank" href="https://every-tuesday.com/gouache-comparison">chart</a>.</p>',
    },
    {
      question: 'I’m brand new to Procreate, will I be able to follow along?',
      answer: '<p>Yep! The course was designed with beginners in mind, which is why it was built to increase in complexity as the course progresses. As long as you take the course in order, you’ll learn a lot about Procreate at a comfortable pace and be able to follow along through every project.</p>',
    },
    {
      question: 'If I recreate these projects following your instruction, can I sell that artwork afterward?',
      answer: '<p>You’ll need to create artwork based on royalty free images if you’d like to sell it afterward. All of the artwork we create uses source photos found on Pinterest and is meant for practice + getting familiar with the techniques and methods first. If you’d like to use a similar royalty free image for each project, then you may sell it afterward.</p>',
    },
  ],
  testimonials: [],
  letsDoThis: {
    imgName: 'procreate301/lets-do-this-2.jpg',
    altTag: 'Enroll in Watercolor lettering for Procreate today!',
    text: 'Welcome to Gouache Botanicals in Procreate, your source for creating stunning digital gouache paintings.',
  },
  sellCard: {
    priceColor: `#557f76`,
    saleColor: `#E97D00`,
    cardImg: 'procreate401/sell-card.jpg',
    saleLink: 'https://courses.every-tuesday.com/purchase?product_id=3048808',
    link: 'https://courses.every-tuesday.com/purchase?product_id=3048809',
    paymentPlanLink: 'https://courses.every-tuesday.com/purchase?product_id=3048810',
    customBtnBackgroundColor: `#75A79E`,
    h2Color: `#557f76`,
    hoverColor: {
      h2: `#fff`,
      text: `#ED856A`,
      overlay: `#75A79E`,
    },
    bullets: [
      'Instant access to all videos and bonuses',
      'Extended license + full Gouache Lovers Procreate Brush Set',
      '4 unique gouache-inspired painting styles',
      'Foliage and floral warm up exercises for every style',
      'All original Procreate project files',
      '2 Bonus smooth style projects',
      'Recoloring, reusing and exporting module',
      '14 day money back guarantee',
    ],
  },
}
export default course
